'use client';

import clsx from 'clsx';
import { CSSProperties, FC } from 'react';
import Image from '@/components/Image';
import { StrapiImage } from '@/types/common';
import css from './style.module.scss';
import { MarqueeDto } from './types';
type Props = {
  data: MarqueeDto;
  className?: string;
};
export const LogosMarquee: FC<Props> = ({
  data,
  className
}) => {
  const {
    items,
    speedSec = 28,
    direction = 'left',
    pauseOnHover = false
  } = data;
  if (!items.length) return null;
  const cssVars = {
    ['--marquee-duration' as any]: `${speedSec}s`,
    ['--marquee-direction' as any]: direction === 'left' ? 'normal' : 'reverse'
  } satisfies CSSProperties;
  const renderItems = (suffix: string) => items.map(item => <div key={`${item.id}-${suffix}`} className={css.item}>
				<Image width={item.image.width} height={item.image.height} src={item.image.url} preload={false} alt={item.alt ? item.alt : item.image.alternativeText ? item.image.alternativeText : 'Partner logo'} />
			</div>);
  return <section className={clsx(css.section, className)} style={cssVars}>
			<div aria-label="Industries marquee" className={clsx(css.viewport, {
      [css.pauseOnHover]: pauseOnHover
    })}>
				<div className={css.marquee}>
					<div className={css.group} aria-hidden="true">
						{renderItems('first')}
					</div>

					<div className={css.group} aria-hidden="true">
						{renderItems('second')}
					</div>
				</div>
			</div>
		</section>;
};
export default LogosMarquee;